export const routerEventInputThumbnail = `query RouterEventInputThumbnail($inputId: ID!) {
  routerEventInputThumbnail(inputId: $inputId) {
    success
    message
    dataJson
  }
}
`;

export const routerEventInputsThumbnail = `query RouterEventInputsThumbnail($inputIds: [ID!]!) {
  routerEventInputsThumbnail(inputIds: $inputIds) {
    success
    message
    dataJson
  }
}
`;
